/* HEALR Wholesale — carton builder (build your own)
   Mixes individual units across products against a minimum (default 20),
   with a live thumbnail tray in the sticky summary panel.

   Sodii's builder fills a fixed 12-slot grid; ours is an open-ended minimum,
   so the tray shows one tile per chosen product with a xN badge rather than
   one tile per unit, and progress runs to the minimum.

   Tiles are built with DOM APIs, not innerHTML — product titles are
   author-controlled strings and go into text/aria, never markup.

   Sibling of wholesale-quick.js, which adds whole cartons. */
(function () {
  var EMPTY_PLACEHOLDERS = 4;

  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }

  function initBuilder(root) {
    var min = parseInt(root.getAttribute('data-min-units'), 10) || 20;
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-sku]'));
    var totalUnitsEl = root.querySelector('[data-total-units]');
    var totalPriceEl = root.querySelector('[data-total-price]');
    var progressEl = root.querySelector('[data-progress]');
    var trayEl = root.querySelector('[data-tray]');
    var addBtn = root.querySelector('[data-add]');
    var noticeEl = root.querySelector('[data-notice]');
    if (!rows.length || !addBtn) return;

    function qtyInput(row) { return row.querySelector('[data-qty]'); }
    function rowQty(row) {
      var input = qtyInput(row);
      if (!input) return 0;
      return Math.max(0, parseInt(input.value, 10) || 0);
    }
    function setRowQty(row, v) {
      var input = qtyInput(row);
      if (input) input.value = Math.max(0, v);
    }

    function buildTile(row, qty) {
      var tile = document.createElement('div');
      tile.className = 'whsl-cb__tile';

      var src = row.getAttribute('data-image');
      var title = row.getAttribute('data-title') || 'Product';
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        tile.appendChild(img);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'whsl-cb__tile-remove';
      remove.setAttribute('aria-label', 'Remove ' + title + ' from your carton');
      remove.textContent = '×';
      remove.addEventListener('click', function () {
        setRowQty(row, 0);
        update();
      });
      tile.appendChild(remove);

      if (qty > 1) {
        var badge = document.createElement('span');
        badge.className = 'whsl-cb__tile-qty';
        badge.textContent = 'x' + qty;
        tile.appendChild(badge);
      }
      return tile;
    }

    function renderTray(chosen) {
      if (!trayEl) return;
      trayEl.textContent = '';
      if (!chosen.length) {
        for (var i = 0; i < EMPTY_PLACEHOLDERS; i++) {
          var empty = document.createElement('div');
          empty.className = 'whsl-cb__tile whsl-cb__tile--empty';
          trayEl.appendChild(empty);
        }
        return;
      }
      chosen.forEach(function (entry) {
        trayEl.appendChild(buildTile(entry.row, entry.qty));
      });
    }

    function update() {
      var units = 0, price = 0, chosen = [];
      rows.forEach(function (row) {
        var q = rowQty(row);
        units += q;
        price += q * (parseFloat(row.getAttribute('data-price')) || 0);
        row.classList.toggle('is-active', q > 0);
        if (q > 0) chosen.push({ row: row, qty: q });
      });

      if (totalUnitsEl) totalUnitsEl.textContent = units;
      if (totalPriceEl) totalPriceEl.textContent = money(price);
      if (progressEl) progressEl.style.width = Math.min(100, (units / min) * 100) + '%';
      renderTray(chosen);

      var short = Math.max(0, min - units);
      root.classList.toggle('is-complete', short === 0 && units > 0);
      addBtn.disabled = short > 0;
      addBtn.textContent = short > 0
        ? 'Add ' + short + ' more unit' + (short === 1 ? '' : 's')
        : (addBtn.getAttribute('data-label') || addBtn.textContent);

      if (noticeEl) noticeEl.hidden = true;
    }

    rows.forEach(function (row) {
      var input = qtyInput(row);
      if (!input) return;
      row.querySelectorAll('[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setRowQty(row, rowQty(row) + parseInt(btn.getAttribute('data-step'), 10));
          update();
        });
      });
      input.addEventListener('input', update);
    });

    var presetBtn = root.querySelector('[data-load-preset]');
    if (presetBtn) presetBtn.addEventListener('click', function () {
      rows.forEach(function (row) { setRowQty(row, parseInt(row.getAttribute('data-preset'), 10) || 0); });
      update();
    });

    var clearBtn = root.querySelector('[data-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function () {
      rows.forEach(function (row) { setRowQty(row, 0); });
      update();
    });

    addBtn.addEventListener('click', function () {
      var items = [], missing = false;
      rows.forEach(function (row) {
        var q = rowQty(row);
        if (q > 0) {
          var vid = row.getAttribute('data-variant-id');
          if (!vid) { missing = true; return; }
          items.push({ id: vid, quantity: q, properties: { _carton: 'Build your own' } });
        }
      });
      if (missing || !items.length) {
        if (noticeEl) {
          noticeEl.textContent = missing
            ? 'These products aren’t connected to Shopify yet — wholesale variants need to be assigned before ordering.'
            : 'Add at least one product to your carton.';
          noticeEl.hidden = false;
        }
        return;
      }
      addBtn.disabled = true;
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          addBtn.disabled = false;
          if (noticeEl) { noticeEl.textContent = 'Something went wrong adding to cart. Please try again.'; noticeEl.hidden = false; }
        });
    });

    // Remember the configured label before the shortfall countdown overwrites it.
    addBtn.setAttribute('data-label', addBtn.textContent.trim());
    update();
  }

  document.querySelectorAll('[data-wholesale-bulk]').forEach(initBuilder);
})();
